import RootCsvMixin from 'GroomyRoot/mixins/Csv.js'

let CsvMixin = {
    mixins: [RootCsvMixin]
}
export default CsvMixin